export function isChapterForDownloadCenter(chapter) {
  if (chapter === 8) {
    return true;
  }
  return false;
}

export function getLanguageFolder(rtl) {
  return rtl ? "arabic" : "english";
}

export function getPdfName(chapter, section) {
  return `${chapter + 1}_${section === 0 ? "cover" : section}.pdf`;
}
